import { render, staticRenderFns } from "./inspectionRouteList.vue?vue&type=template&id=96f9e450&scoped=true"
import script from "./inspectionRouteList.vue?vue&type=script&lang=js"
export * from "./inspectionRouteList.vue?vue&type=script&lang=js"
import style0 from "./inspectionRouteList.vue?vue&type=style&index=0&id=96f9e450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f9e450",
  null
  
)

export default component.exports